/** Format catalog/checkout minor units (centésimos) as UYU (or other ISO currency). */
export function formatUyMinor(minor: number, currency = "UYU"): string {
  const n = minor / 100;
  return n.toLocaleString("es-UY", {
    style: "currency",
    currency: currency === "UYU" ? "UYU" : currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
